// es-lint-disable-next-line no-unused-vars
import { useState, useRef, useEffect } from 'react';
import startcase from 'lodash.startcase';
import { DateTime } from 'luxon';
import { device } from '../../../utils/styled-component-mixins';
import useIsMounted from '../../custom-hooks/useIsMounted';
import useMediaQuery from '../../custom-hooks/useMediaQuery';
import ContentCardWrapperStyled from '../styled-components/ContentCardWrapperStyled';
import onLoad from '../../../utils/on-load';

const ContentCard = (props) => {
  const { cardProps, item } = props;
  const [isHovered, setIsHovered] = useState(false);
  const featuredCardRef = useRef(null);
  const isMounted = useIsMounted();
  const isDesktop = useMediaQuery(device.desktop);

  const setContentHeight = () => {
    const content = featuredCardRef.current.querySelectorAll('.animated-content')[0];
    const description = featuredCardRef.current.querySelectorAll('.animated-content p')[0];
    const descriptionStyles = getComputedStyle(description);
    const contentHeight = content.getBoundingClientRect().height;
    const descriptionHeight =
      description.getBoundingClientRect().height + parseInt(descriptionStyles.marginBottom, 10);
    const initialHeight = contentHeight - descriptionHeight;
    const imageOffset = featuredCardRef.current
      .querySelectorAll('.featured-card-image')[0]
      .getBoundingClientRect().height;

    featuredCardRef.current
      .querySelectorAll('.content-wrapper')[0]
      .style.setProperty('--animated-content-height', `${initialHeight}px`);
    content.style.setProperty('--animated-content-height', `${initialHeight}px`);
    content.style.setProperty('--image-offset', `${imageOffset}px`);
  };

  useEffect(() => {
    if (isDesktop) {
      onLoad().then(() => {
        setContentHeight();
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isDesktop, props.recalculatedHeight, props.activeTab]);

  const [thumbnail, setThumbnail] = useState('');

  useEffect(() => {
    setThumbnail(item.thumbnail);
  }, [item.thumbnail]);

  return (
    <ContentCardWrapperStyled
      className="content-card-wrapper"
      thumbnail={thumbnail}
      ref={featuredCardRef}
    >
      <a
        href={item.externalUrl ? item.externalUrl : item.url}
        target={item.externalUrl ? '_blank' : props.urlTarget}
        aria-label={`Read more about ${item.pageTitle}`}
        className="no-underline-link"
      >
        <div
          className={`content-card content-card-${cardProps.layout} content-card-media-${cardProps.mediaSide}`}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          {item.isFeatured && cardProps.layout === 'standard' && (
            <div className="featured-tag">{cardProps.featuredTagText}</div>
          )}
          <div className="featured-card-image">
            {(item.category === 'podcast' || item.category === 'video') && (
              <span className="card-icon-wrapper">
                <span className="material-icons">
                  {item.category === 'podcast' ? 'mic_none' : 'play_arrow'}
                </span>
              </span>
            )}
          </div>
          <div className="featured-card-content">
            <div
              className={`animation-wrapper ${isHovered ? 'hover-in' : 'hover-out'}
              ${isMounted && 'mounted'}`}
            >
              <div className="content-wrapper">
                <div className="animated-content">
                  <div className="text-wrapper">
                    {item.category && <span className={`tag`}>{startcase(item.category)}</span>}
                    <h3>{item.pageTitle}</h3>
                    {item.publishDate && (
                      <span suppressHydrationWarning className="publish-date">
                        {DateTime.fromISO(item.publishDate).toLocaleString({
                          day: 'numeric',
                          month: 'long',
                          year: 'numeric'
                        })}
                      </span>
                    )}
                    <p>{item.description}</p>
                  </div>
                  <div className="overflow-wrapper">
                    {item.ctaText && (
                      <div className="cta-wrapper">
                        <span>{item.ctaText}</span>
                        <span className="material-icons-round" aria-hidden="true">
                          chevron_right
                        </span>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </a>
    </ContentCardWrapperStyled>
  );
};

ContentCard.defaultProps = {
  urlTarget: '_self'
};

export default ContentCard;
